const pairByUid = new Map<string, CryptoKeyPair>();

export function setSessionChatKeyPair(uid: string, pair: CryptoKeyPair): void {
  if (!uid) return;
  pairByUid.set(uid, pair);
}

export function clearSessionChatKeyPair(uid: string): void {
  if (!uid) return;
  pairByUid.delete(uid);
}

export async function importEcdhPairFromBackup(backup: {
  privateJwk: JsonWebKey;
  publicJwk: JsonWebKey;
}): Promise<CryptoKeyPair> {
  const { privateJwk, publicJwk } = backup;
  const privateKey = await crypto.subtle.importKey(
    'jwk',
    privateJwk,
    { name: 'ECDH', namedCurve: 'P-256' },
    true,
    ['deriveBits']
  );
  const publicKey = await crypto.subtle.importKey(
    'jwk',
    publicJwk,
    { name: 'ECDH', namedCurve: 'P-256' },
    true,
    []
  );
  return { privateKey, publicKey };
}

/**
 * Пара ключей только в памяти после bootstrap (`loadChatIdentityFromFirestore` + `setSessionChatKeyPair`).
 * Персистентность — `users/{uid}.chatEcdhKeyPairBackup` в Firestore.
 */
export async function getOrCreateChatKeyPair(userId: string): Promise<CryptoKeyPair> {
  if (!userId || typeof crypto === 'undefined' || !crypto.subtle) {
    throw new Error('Web Crypto unavailable');
  }
  const cached = pairByUid.get(userId);
  if (cached) return cached;
  throw new Error('Chat key pair not initialized');
}

export async function exportChatPublicKeyJwk(publicKey: CryptoKey): Promise<JsonWebKey> {
  return crypto.subtle.exportKey('jwk', publicKey) as Promise<JsonWebKey>;
}

export async function importPeerPublicKey(jwk: JsonWebKey): Promise<CryptoKey> {
  return crypto.subtle.importKey(
    'jwk',
    jwk,
    { name: 'ECDH', namedCurve: 'P-256' },
    false,
    []
  );
}
